import { Component } from '@angular/core';
import { EnumScales, TimeRange } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { ControlPageStore, GraphModes } from '@pages/control-page/control-page-store.service';
import { combineLatest, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-control-page-header',
  templateUrl: './control-page-header.component.html',
  styleUrls: ['./control-page-header.component.scss']
})
export class ControlPageHeaderComponent {

  viewModel$ = combineLatest({
    scale: this.controlPageStore.scale$,
    timeRange: this.controlPageStore.timeRange$,
  });

  constructor(
    private controlPageStore: ControlPageStore,
    private cardService: ControlPageCardService,
  ) { }

  async selectScale(scale: EnumScales) {
    const card = await firstValueFrom(this.controlPageStore.card$.pipe(isDefined()));
    if (scale === EnumScales.DAY || scale === EnumScales.WEEK || !this.cardService.supportGraphModes(card.graphType)) {
      this.controlPageStore.setOptions({graphMode: GraphModes.DEFAULT});
    }
    else {
      this.controlPageStore.setOptions({graphMode: GraphModes.MINMAX});
    }
    this.controlPageStore.selectScale(scale);
  }

  selectTimeRange(timeRange: TimeRange) {
    this.controlPageStore.selectTimeRange(timeRange);
  }

}
